import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/styles/reset.css'
import ViewUI from 'view-design';
import 'view-design/dist/styles/iview.css';
Vue.use(ViewUI);

import axios from '@/lib/axios';
import moment from 'moment'
Vue.prototype.axios = axios
Vue.prototype.moment = moment
import numberInput from '@/directives/numberInput';
Vue.directive('number-input', numberInput);
Vue.config.productionTip = false

router.afterEach(() => {
    window.scroll(0, 0);
    // document.body.scrollTop = document.documentElement.scrollTop = 0;
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
